import React from 'react';

export const bgColors = ['bg-grey-light', 'bg-green3', 'bg-blue-fonce'];
export const textColors = ['', 'text-white', ''];
export const labelClasses = ['text-white bg-green', 'text-grey2 bg-white ', 'text-white bg-green'];

const initPage = 0;
export default React.createContext({page: initPage, textColor: textColors[initPage], labelClass: labelClasses[initPage]});